import * as React from 'react';
import { TileProps } from 'ui/tile/tile';
import { Permission, MeatballMenu, PromptConfirmationModal, DisplayCodes } from 'ui';

import styles from './category-tile.scss';

interface CategoryTileProps extends TileProps {
  numberOfEntitiesInCategory: number;
}

export class CategoryTile extends React.PureComponent<CategoryTileProps> {

  private handleDelete = (e?: any) => {
    this.props.onDeleteDocumentItem && this.props.onDeleteDocumentItem();
  }

  public render() {
    const { componentId, className, primaryKey, children, numberOfEntitiesInCategory,
            canBeRemoved, enabledChildEntityOperations } = this.props;
    const { categoryTile, categoryTileHeading, displayCodes, longDescription, hasMeatball } = styles;

    const count = numberOfEntitiesInCategory ? ` (${numberOfEntitiesInCategory})` : '';

    const valueWithCount = {...primaryKey, description: `${primaryKey.description}${count}`};
    const withMeatballStyles = enabledChildEntityOperations?.remove ? hasMeatball : '';

    return (
      <div key={`${componentId}-${primaryKey.value}`} className={`${categoryTile} ${className}`}>
        <div className={`${categoryTileHeading} ${withMeatballStyles}`}>
          <h3>
            <DisplayCodes
              componentId={`${componentId}-code`}
              className={displayCodes}
              valueItems={[valueWithCount]}
              displayIcon={'left'}
              options={undefined}
              onChange={undefined}
            />

            {primaryKey.longDescription &&
            <div className={longDescription}>
              {primaryKey.longDescription}
            </div>}
          </h3>
          {!canBeRemoved && this.renderContextMenu()}
        </div>
        <div className="row">{children}</div>
      </div>
    );
  }

  private renderContextMenu() {
    const { enabledChildEntityOperations, textDelete, textDeleteMessage, textContinue, textCancel } = this.props;
    const { tileDropdown } = styles;

    return (
      <Permission requireAny="remove" permissions={enabledChildEntityOperations}>
        <div className={tileDropdown}>
          <MeatballMenu>
              <Permission requireAll="remove" permissions={enabledChildEntityOperations} isListElement={true}>
                <PromptConfirmationModal
                  title={textDelete}
                  description={textDeleteMessage}
                  continueText={textContinue}
                  cancelText={textCancel}
                  onContinue={this.handleDelete}>
                  <button type="button" className="dropdown-item">{textDelete}</button>
                </PromptConfirmationModal>
              </Permission>
          </MeatballMenu>
        </div>
      </Permission>
    );
  }
}
